module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>The Column component is part of the Nessie layout system. Columns <strong>must</strong> be\ndirect children of Grid (or Row) components.</p>\n<p>For full details about Grids and the Nessie layout system, see the Grid\ncomponent.</p>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Column/README.md
// module id = 340
// module chunks = 0